/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SavedStateOverview } from "./SavedStateOverview";
import {
  SavedStateOverviewFromJSON,
  SavedStateOverviewFromJSONTyped,
  SavedStateOverviewToJSON,
  SavedStateOverviewToJSONTyped,
} from "./SavedStateOverview";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface InitialSavedStateOverview
 */
export interface InitialSavedStateOverview {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly savedState?: SavedStateOverview;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uuid?: string;
}

/**
 * Check if a given object implements the InitialSavedStateOverview interface.
 */
export function instanceOfInitialSavedStateOverview(
  value: object
): value is InitialSavedStateOverview {
  return true;
}

export function InitialSavedStateOverviewFromJSON(json: any): InitialSavedStateOverview {
  return InitialSavedStateOverviewFromJSONTyped(json, false);
}

export function InitialSavedStateOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InitialSavedStateOverview {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    savedState:
      json["saved_state"] == null ? undefined : SavedStateOverviewFromJSON(json["saved_state"]),
    id: json["id"] == null ? undefined : json["id"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function InitialSavedStateOverviewToJSON(json: any): InitialSavedStateOverview {
  return InitialSavedStateOverviewToJSONTyped(json, false);
}

export function InitialSavedStateOverviewToJSONTyped(
  value?: Omit<InitialSavedStateOverview, "url" | "savedState" | "id" | "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
